'use strict';

define('features/mirai-locator/mini-locator',[
  'jquery',
  'lib/util/tda.config',
  'zipTools',
  'txt!./mini.locator.results.hbs',
  'bat',
  'lib/scroller',
  'lib/analytics/blocks/index',
  'lib/analytics/pageload',
  'lib/analytics/click',
  'lib/analytics/context.add',

  // side effect includes
  'bat',
  'Handlebars',
  'h5validate',
], function (
  $,
  tdaConfig,
  zipTools,
  textTemplate,
  bat,
  scroller,
  blocks,
  anPageLoad,
  anClicks,
  anAddContext
) {
  var __minLocatorTpl = Handlebars.compile(textTemplate);

  var	miniStationLocator = {
    init: function (el, config) {
      this.$el = $(el);
      this.$searchSubmit = $('.station-search-form__btn', this.$el);
      this.$searchResults = $('#js-mini-locator-results', this.$el);
      this.config = config;
      $('.page-mirai-mini-station-locator').show();
      this.listenersAttach();
      $('.page-mirai-mini-station-locator form').h5Validate({});
      this.autolocateClick();
      this.analtyicsLoad();
    },

    locationsLoadResults: function (locationsResponseData) {
      var self = this;
      var searchValue = $('#stationSearch-search-value', self.$el).val();
      var locationsData = { locations: [] };

      // BAT-5003 - Only show Open stations (status = 'Open_Now')
      // Build a separate 'Open Now' array and iterate over that one
      // instead of all locations
      var top3OpenLocationsArray = [];
      $.each(locationsResponseData, function (i, locationItem) {
        if (locationItem.status === 'Open_Now') {
          top3OpenLocationsArray.push(locationItem);
        }
      });
      // var top3Locations = locationsResponseData ? locationsResponseData.slice(0, 3) : [];
      var top3Locations = top3OpenLocationsArray ? top3OpenLocationsArray.slice(0, 3) : [];

      var erroredLocations = $.grep(top3Locations, function (loc) {
        return loc.distanceWithoutMiles === 0;
      });
      if (locationsResponseData && top3Locations.length === 3 && erroredLocations.length === 0) {
        $('.station-search', self.$el).hide();
        $.each(top3Locations, function (indx, locItem) {
          locationsData.locations.push({
            name: locItem.name,
            addressLine1: locItem.addressLine1,
            addressLine2: locItem.addressLine2,
            distanceWithoutMiles: locItem.distanceWithoutMiles,
            actionDetailsUrl: '/' + tdaConfig.site.context_url + '/mirai/stations?search=' + searchValue + '&id=' + locItem.id,
            dealer_code: locItem.id,
            dealer_name: locItem.name,
            dealer_city: locItem.addressLine2,
            dealer_state: locItem.addressLine2,
            dealer_metro: locItem.addressLine2,
            dealer_zipcode: locItem.addressLine2,
          });
        });

        var finalCtx = $.extend({}, locationsData, self.config);
        self.$searchResults.html(__minLocatorTpl(finalCtx));
        console.log('Mini locator result CTX: ', finalCtx); // eslint-disable-line no-console
        self.analyticsDealerResults(locationsData.locations);
      } else {
        miniStationLocator.errorModal.show();
        bat.util.loader.hideLoader();
      }
    },

    errorModal: {
      show: function () {
        $('#modal-station-results-error').modal('show');
        $('#dismiss-stations-modal').on('click', function () {
          $('#modal-station-results-error').modal('hide');
        });
      }
    },

    listenersAttach: function () {
      var self = this;
      this.$searchSubmit.on('click', function (e) {
        e.preventDefault();
        var valid = $('.page-mirai-mini-station-locator form').h5Validate('allValid');
        var searchValue = $('#stationSearch-search-value').val();
        var searchValueIsNumber = false;
        if (!valid) { return; }
        if (searchValue.match(/^\d+$/)) { searchValueIsNumber = true; }
        if (searchValueIsNumber && searchValue.length !== 5) {
          miniStationLocator.errorModal.show();
          return;
        }
        if ($.trim(searchValue) === '') {
          miniStationLocator.errorModal.show();
          return;
        }

        $('.station-search-form__btn').attr('disabled', true);
        bat.util.loader.showLoader();


        $.ajax({
          type: 'GET',
          url: '/fcv-consumer/fcvappservice/getAllFuelStations/' + searchValue + '?callback=miniStationLocator.locationsLoadResults',
          dataType: 'json'
        }).done(function (data) {
          self.locationsLoadResults(data);
          $("a[data-destination='mirai-stations']").each(function (index, item) {
            var dpath = '/' + tdaConfig.site.context_url + '/mirai/stations?search=' + searchValue ;
            var $item = $(item);
            $item.attr('href', dpath);
          });
          $('.station-search-form__btn').attr('disabled', false);

          bat.util.loader.hideLoader();
        })
          .fail(function (jqXHR, textStatus, errorThrown) {
            miniStationLocator.errorModal.show();
            $('.station-search-form__btn').attr('disabled', false);
            bat.util.loader.hideLoader();
            console.error('DISREST fail: ', textStatus + errorThrown);
          });
      });
    },

    autolocateClick: function () {
      var self = this;

      $('#autolocate', this.$el).on('click', function (e) {
        e.preventDefault();
        var success = function (res) {
          $('#stationSearch-search-value', self.$el).val(res);
          self.$searchSubmit.trigger('click');
        };
        zipTools.geoLocationZip.detect(success, zipTools.reLoadDealerSearchWithoutZip);
      });
    },

    analtyicsLoad: function () {
      var $scope = this.$el;
      anClicks($scope);
      scroller.add($scope, {
        after: function () {
          anPageLoad($scope);
        }
      });
    },

    analyticsDealerResults: function (dealers) {
      anAddContext(
        this.$el,
        blocks.listBlock(dealers.length, 'grid'),
        blocks.dealerSearchBlock($('#stationSearch-search-value', this.$el).val(), 'zip', dealers.length)
      );

      anPageLoad(
        this.$el,
        blocks.keyMetrics('km-dealer-search')
      );

      $('.station-results-location', this.$el).each(function (idx) {
        anAddContext($(this), blocks.dealerBlock(dealers[idx]));
      });
    }
  };

  return miniStationLocator;
});

